import { bindActionCreators } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import { CardStatus, CardType } from 'src/model/enum/enums';
import { Card, learnActions } from '../../store/slices/learnSlice';
import { RootState } from '../../store/store';
import { useState } from 'react';

export const useLearn = () => {
    const dispatch = useDispatch();
    const { cards, currentCardIndex } = useSelector((state: RootState) => state.learn);
    const ac = bindActionCreators(learnActions, dispatch);

    const [isFinished, setIsFinished] = useState(false);

    const initializeSequence = (wordIds: number[]) => {
        if (wordIds.length === 0) {
            setIsFinished(true);
            return;
        }

        const newCards: Card[] = [];
        let order = 0;

        // Add first learn card
        newCards.push({
            id: `${CardType.Learn}-${wordIds[0]}`,
            type: CardType.Learn,
            wordId: wordIds[0],
            status: CardStatus.Pending,
            order: order++,
        });

        // For each subsequent word
        for (let i = 1; i < wordIds.length; i++) {
            // Add learn card for current word
            newCards.push({
                id: `${CardType.Learn}-${wordIds[i]}`,
                type: CardType.Learn,
                wordId: wordIds[i],
                status: CardStatus.Pending,
                order: order++,
            });

            // Add challenge cards for previous 2-3 words
            const startIndex = Math.max(0, i - 3); // Start from 2-3 words back
            for (let j = startIndex; j < i; j++) {
                newCards.push({
                    id: `${CardType.Challenge}-${wordIds[j]}`,
                    type: CardType.Challenge,
                    wordId: wordIds[j],
                    status: CardStatus.Pending,
                    order: order++,
                });
            }
        }

        ac.setCards(newCards);
        ac.setCurrentCardIndex(0);
    };

    const completeCurrentCard = () => {
        if (currentCardIndex < cards.length - 1) {
            ac.updateCardStatus({ index: currentCardIndex, status: CardStatus.Completed });
            ac.setCurrentCardIndex(currentCardIndex + 1);
        }
        else {
            setIsFinished(true);
        }
    };

    const currentCard = cards[currentCardIndex];

    return {
        cards,
        currentCard,
        currentCardIndex,
        isFinished,
        initializeSequence,
        completeCurrentCard,
    };
};
